import classNames from 'classnames'
import style from './LoadingDot.module.less'
import { useState } from 'react'


export const LoadingDot = (p: { size?: 'small' | 'normal' | 'large' }) => {
  const [size] = useState(p.size || 'small')
  return (
    <span className={style.loadingDot}>
      <span className={classNames(style.dot, style[size])}>·</span>
      <span className={classNames(style.dot, style[size])}>·</span>
      <span className={classNames(style.dot, style[size])}>·</span>
    </span>
  )
}
